// @ts-nocheck

export const localeCodes =  [
  "tr",
  "en",
  "ar"
]
export const localeLoaders = {
  tr: [
    {
      key: "locale_tr_46json_fd3b0a61",
      load: () => import("#nuxt-i18n/fd3b0a61" /* webpackChunkName: "locale_tr_46json_fd3b0a61" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_ar_46json_223a5e9d",
      load: () => import("#nuxt-i18n/223a5e9d" /* webpackChunkName: "locale_ar_46json_223a5e9d" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "tr",
    iso: "tr-TR",
    name: "Türkçe",
    language: "tr-TR"
  },
  {
    code: "en",
    iso: "en-US",
    name: "English",
    language: "en-US"
  },
  {
    code: "ar",
    iso: "ar-SA",
    name: "العربية",
    dir: "rtl",
    language: "ar-SA"
  }
]

